/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-calendar-input': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" d="M3 7H2v1h1V7zM4.5 7h1v1h-1V7zM8 7H7v1h1V7zM2 5h1v1H2V5zM5.5 5h-1v1h1V5zM7 5h1v1H7V5z" _fill="#20354E" fill-opacity=".5"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0h-7A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10h7A1.5 1.5 0 0 0 10 8.5v-7A1.5 1.5 0 0 0 8.5 0zM9 3V1.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V3h8zM1 4v4.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4H1z" _fill="#20354E" fill-opacity=".5"/>'
  }
})
